import type { SlideImage } from "yet-another-react-lightbox";

export function Gallery2022(){
  
const slides: SlideImage[] = [
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_001.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_001.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_002.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_002.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_003.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_003.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_004.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_004.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_005.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_005.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_006.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_006.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_007.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_007.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_008.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_008.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_009.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_009.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_010.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_010.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_011.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_011.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_012.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_012.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_013.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_013.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_014.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_014.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_015.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_015.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_016.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_016.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_017.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_017.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_018.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_018.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_019.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_019.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_020.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_020.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_021.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_021.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_022.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_022.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_023.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_023.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_024.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_024.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_025.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_025.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_026.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_026.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_027.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_027.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_028.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_028.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_029.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_029.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_030.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_030.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_031.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_031.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_032.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_032.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_033.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_033.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_034.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_034.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_035.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_035.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_036.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_036.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_037.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_037.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_038.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_038.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_039.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_039.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_040.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_040.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_041.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_041.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_042.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_042.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_043.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_043.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_044.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_044.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_045.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_045.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_046.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_046.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_047.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_047.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_048.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_048.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_049.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_049.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_050.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_050.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_051.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_051.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_052.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_052.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_053.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_053.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_054.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_054.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_055.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_055.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_056.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_056.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_057.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_057.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_058.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_058.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_059.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_059.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_060.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_060.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_061.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_061.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_062.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_062.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_063.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_063.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_064.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_064.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_065.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_065.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_066.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_066.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_067.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_067.jpg"
        },
        {
          "src": "https://jamhaw.com/images/gallery/Gallery2022/IMG_068.jpg",
          "alt": "https://jamhaw.com/images/gallery/Gallery2022/SML_068.jpg"
        }
      ];

     return slides;
} 
